import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import filesize from 'filesize';
import { useAssetPreviews } from '../hooks/useAssetPreviews';

function getFileName(fileName) {
    if (fileName !== null) {
        return fileName.split(/(\\|\/)/g).pop();
    }
}

const ArticleDataGalleryModal = ({ items, onClose, startingIndex }) => {
    const [currentIndex, setCurrentIndex] = useState(startingIndex);

    // Hook per l' immagine di anteprima degli assets
    const { previewImages, loading, error } = useAssetPreviews(items);

    useEffect(() => {
        setCurrentIndex(startingIndex);
    }, [startingIndex]);

    const getCurrentItem = () => items[currentIndex];
    const hasNext = () => currentIndex < items.length - 1;
    const hasPrevious = () => currentIndex - 1 >= 0;

    const nextItem = () => setCurrentIndex(prev => prev + 1);
    const previousItem = () => setCurrentIndex(prev => prev - 1);

    const currentItem = getCurrentItem();
    const hasNextItem = hasNext();
    const hasPreviousItem = hasPrevious();

    // Usa l'immagine di preview invece dell'originale
    const imageSrc = previewImages[currentItem?.src] || currentItem?.src;

    return (
        <Fragment>
            <div className="modal-header">
                <span
                    className="btn btn-clear float-right"
                    aria-label="Close"
                    onClick={onClose}
                />
                <div className="modal-title h4">{currentItem?.label}</div>
            </div>
            <div className="divider" />
            <div className="modal-body text-center">
                {loading && <div>Caricamento preview...</div>}

                <div style={{ position: 'absolute', top: '40%' }}>
                    <i
                        onClick={hasPreviousItem ? previousItem : () => {}}
                        className={cx('icon icon-4x icon-arrow-left', {
                            'c-hand': hasPreviousItem,
                            'text-gray': !hasPreviousItem
                        })}
                    />
                </div>

                <img
                    className="img-responsive"
                    style={{ margin: '0 auto', maxHeight: '60vh' }}
                    src={imageSrc} // Usa la preview!
                    alt={currentItem?.label}
                />

                <div style={{ position: 'absolute', top: '40%', right: 0 }}>
                    <i
                        onClick={hasNextItem ? nextItem : () => {}}
                        className={cx('icon icon-4x icon-arrow-right', {
                            'c-hand': hasNextItem,
                            'text-gray': !hasNextItem
                        })}
                    />
                </div>

                <div className="my-2" />
                <div className="my-2 text-center">
                    <strong>Nome del file:</strong> {getFileName(currentItem?.filename)}
                    {currentItem?.size && (
                        <Fragment>
                            {' '} - <strong>Kb:</strong>{' '}
                            {filesize(currentItem.size, {
                                separator: ',',
                                base: 10
                            })}
                        </Fragment>
                    )}
                </div>

                <a
                    className="btn btn-lg btn-primary btn-rounded"
                    href={currentItem?.src}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="icon icon-download" /> DOWNLOAD
                </a>
            </div>
            <div className="modal-footer" />
        </Fragment>
    );
};

ArticleDataGalleryModal.propTypes = {
    items: PropTypes.array,
    onClose: PropTypes.func.isRequired,
    startingIndex: PropTypes.number
};

ArticleDataGalleryModal.defaultProps = {
    items: [],
    startingIndex: 0
};

export default ArticleDataGalleryModal;